import {
  Box,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CommonTable from "../../common/CommonTable";
import GreenButton from "../../common/button/greenButton";
import OrangeButton from "../../common/button/orangeButton";
import VerticalTable from "../../common/verticalTable";
import { useDispatch, useSelector } from "react-redux";
import masterActions from "../../redux/master/actions";
import customerActions from "../../redux/customer/actions";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";

export default function Index() {
  const dispatch = useDispatch();
  const [courseid, setCourseId] = useState(0);
  const [applicantionid, setapplicantionId] = useState("");
  const [emailid, setEmailId] = useState("");
  const [mobileno, setMobileNo] = useState("");
  const { courseList } = useSelector((state) => state.masterReducer);
  const { applicationStatus } = useSelector((state) => state.customerReducer);
  const [courseError, setCourseError] = useState("");
  const [commonError, setCommonError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [stepsData, setStepsData] = useState([]);
  const [buttonClick, setButtonClick] = useState(false);

  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
    return () => {
      dispatch({
        type: customerActions.SET_APPLICATION_STATUS,
        payload: [],
      });
    };
  }, []);

  const onChangeCourse = (e) => {
    setCourseId(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmailId(e.target.value);
  };

  const handleMobileChange = (e) => {
    setMobileNo(e.target.value);
  };

  const handleApplicationChange = (e) => {
    setapplicantionId(e.target.value);
  };

  const handleGenerate = () => {
    setButtonClick(true);
    let hasError = false;

    if (courseid === 0) {
      setCourseError("Course is required");
      hasError = true;
    } else {
      setCourseError("");
    }

    if (!emailid && !mobileno && !applicantionid) {
      setCommonError(
        "Atleast Email ID or Mobile No or Application No or DOB or Candidate Name is required"
      );
      hasError = true;
    }
    else {
      setCommonError("");
    }

    if (emailid && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailid)) {
      setEmailError("Please enter a valid Email ID");
      hasError = true;
    }
    else {
      setEmailError("");
    }

    // mobile validation
    if (mobileno && !/^[0-9]{10}$/.test(mobileno)) {
      setMobileError("Mobile No must be 10 digits");
      hasError = true;
    }
    else {
      setMobileError("");
    }

    if (!hasError) {
      dispatch({
        type: customerActions.GET_APPLICATION_STATUS,
        payload: {
          courseid: courseid,
          emailid: emailid,
          mobileno: mobileno,
          applicantionid: applicantionid,
        },
      });
    }
  };

  let applicationColumns = [
    {
      name: "Application No",
      dataIndex: "applicationNo",
    },
    {
      name: "Name",
      dataIndex: "candidateName",
    },
    {
      name: "Registered Email Id",
      dataIndex: "candidateEmail",
    },
    {
      name: "Registered Mobile No",
      dataIndex: "candidateMobile",
    },
  ];

  const dataTableData =
    applicationStatus?.applicationstatusreport?.map((item) => ({
      applicationNo: item.applicantid || "N/A",
      candidateName: item.candidatename,
      candidateEmail: item.emailid,
      candidateMobile: item.mobileno
    })) || [];

  useEffect(() => {
    if (applicationStatus?.applicationstatusreport.length) {
      const { status, isApplicationPrinted, uploaddetailstatus } = applicationStatus.applicationstatusreport[0];

      const stepsConfig = [
        { id: 1, label: "Personal Details" },
        { id: 2, label: "Address Details" },
        { id: 3, label: "Domicile and Category Details" },
        { id: 4, label: "Qualification Details" },
        { id: 5, label: "Set Examination Center Preferences" },
        { id: 6, label: "Upload Required Document for Proof of Identity" },
        { id: 7, label: "Preview and Validate Information" },
        { id: 8, label: "Fee Paid And Confirmed" },
        { id: 9, label: "Application Printed" },
      ];

      const stepsData = stepsConfig.map(({ id, label }) => {
        let stepStatus = "";

        // Step 1 → Personal Details (status 0 or 1)
        if (id === 1 && (status === 0 || status >= 1)) {
          stepStatus = <GreenButton title="completed" flag="true"/>;
        }
        // Step 9 → Application Printed
        else if (id === 9 && status >= 7 && isApplicationPrinted) {
          stepStatus = <GreenButton title="completed" flag="true"/>;
        }
        // Step 8 → Fee Paid
        else if (id === 8 && status >= 7) {
          stepStatus = <GreenButton title="completed" flag="true"/>;
        }
        // Step 7 → Preview (only if upload complete)
        else if (id === 7 && status >= 6 && uploaddetailstatus === 2) {
          stepStatus = <GreenButton title="completed" flag="true"/>;
        }
        // Step 6 → Upload Required Doc
        else if (id === 6 && status >= 5 && uploaddetailstatus === 2) {
          stepStatus = <GreenButton title="completed" flag="true"/>;
        }
        // Steps 2–5 follow normal status
        else if (id >=2 && id <= 5 && status >= id) {
          stepStatus = <GreenButton title="completed" flag="true"/>;
        }
        else {
          stepStatus = <OrangeButton title="Pending" flag="true"/>;
        }
        return {
          stepId: `Step ${id}`,
          stepDetails: label,
          status: stepStatus,
        };
      });

      setStepsData(stepsData);
    } else {
      setStepsData([])
    }
  }, [applicationStatus]);

  let applicationStatusColumns = [
    {
      name: "Step ID",
      dataIndex: "stepId",
    },
    {
      name: "Step Details",
      dataIndex: "stepDetails",
    },
    {
      name: "Status",
      dataIndex: "status",
    },
  ];

  return (
    <>
      <Box
        sx={{
          margin: "1rem auto",
          backgroundColor: "rgba(255, 255, 255, 1)",
          borderRadius: "8px",
          padding: "10px",
        }}
      >
        <Card sx={{ p: 2 }}>
          <Typography>Check Application Status</Typography>

          <Grid item sm={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              sx={{ gap: 2, flexWrap: "wrap", mt: 2 }}
            >
              <FormControl error={!!courseError} sx={{ width: "220px" }}>
                <Select
                  size="small"
                  onChange={onChangeCourse}
                  value={courseid}
                  defaultValue={0}
                  sx={{ height: "56px" }}
                >
                  <MenuItem value={0} selected>
                    Select Course <span style={{ color: "red" }}>*</span>
                  </MenuItem>
                  {courseList?.all
                   ?.filter((course) => course.isactive === "1")
                    ?.map((course, i) => (
                      <MenuItem key={i} value={course.courseid}>
                        {course.coursename}
                      </MenuItem>
                    ))}
                </Select>
                {courseError && (
                  <Typography variant="caption" color="error">
                    {courseError}
                  </Typography>
                )}
              </FormControl>

              <FormControl
                sx={{ width: "220px" }}
                variant="outlined"
                error={!!commonError || !!emailError}
              >
                <InputLabel htmlFor="search-email">
                  Search by Email ID
                </InputLabel>
                <OutlinedInput
                  id="search-email"
                  value={emailid}
                  onChange={handleEmailChange}
                  label="Search by Email ID"
                />
                {(commonError || emailError) && (
                  <Typography variant="caption" color="error">
                    {commonError || emailError}
                  </Typography>
                )}
              </FormControl>

              <FormControl
                sx={{ width: "220px" }}
                variant="outlined"
                error={!!commonError || !!mobileError}
              >
                <InputLabel htmlFor="search-mobile">
                  Search by Mobile No
                </InputLabel>
                <OutlinedInput
                  id="search-mobile"
                  value={mobileno}
                  onChange={handleMobileChange}
                  label="Search by Mobile No"
                />
                {(commonError || mobileError) && (
                  <Typography variant="caption" color="error">
                    {commonError || mobileError}
                  </Typography>
                )}
              </FormControl>

              <FormControl
                sx={{ width: "220px" }}
                variant="outlined"
                error={!!commonError}
              >
                <InputLabel htmlFor="search-application">
                  Search by Application No
                </InputLabel>
                <OutlinedInput
                  id="search-application"
                  value={applicantionid}
                  onChange={handleApplicationChange}
                  label="Search by Application No"
                />
                {commonError && (
                  <Typography variant="caption" color="error">
                    {commonError}
                  </Typography>
                )}
              </FormControl>

              <Box sx={{ marginTop: 1 }}>
                <BluePrimaryButton
                  title={"Generate"}
                  handleSubmit={handleGenerate}
                />
              </Box>
            </Box>
          </Grid>

          <Box sx={{ mb: 2 }}>
            <VerticalTable
              columnData={applicationColumns}
              tableData={dataTableData || []}
            />
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "500",
                color: "black",
                fontSize: "20px",
                lineHeight: "24px",
                mb: 2,
                backgroundColor: "whitesmoke",
                padding: "8px",
                borderRadius: "4px",
              }}
            >
              Application Form Status{" "}
            </Typography>
          </Box>

          {stepsData[0]?.status != "" && (
            <CommonTable
              columnData={applicationStatusColumns}
              tableData={stepsData || []}
            />
          )}

          {buttonClick && stepsData[0]?.status == "" && (
            <Box>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", textAlign: "center" }}
              >
                No Records Found
              </Typography>
            </Box>
          )}
        </Card>
      </Box>
    </>
  );
}
